module.exports = __webpack_public_path__ + "img/commodiousToolbox.514e327f.webp";